import TextRight from '@crehana/compass.icons.outline/TextRight';
import { Button } from '@crehana/compass.ui/button';
import clsx from 'clsx';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var HanaHistorialToggleButton = function HanaHistorialToggleButton(_ref) {
  var label = _ref.label,
    onClick = _ref.onClick,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$buttonClassName = _ref.buttonClassName,
    buttonClassName = _ref$buttonClassName === void 0 ? '' : _ref$buttonClassName,
    _ref$labelClassName = _ref.labelClassName,
    labelClassName = _ref$labelClassName === void 0 ? '' : _ref$labelClassName,
    _ref$iconSize = _ref.iconSize,
    iconSize = _ref$iconSize === void 0 ? 20 : _ref$iconSize,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  return /*#__PURE__*/_jsxs("div", {
    className: "tw-flex tw-items-center tw-gap-1 ".concat(className),
    children: [/*#__PURE__*/_jsx(Button, {
      type: "button",
      variant: "white",
      className: clsx('tw-px-1.2', buttonClassName),
      onClick: onClick,
      loading: loading,
      disabled: disabled,
      "aria-label": label,
      title: label,
      children: /*#__PURE__*/_jsx(TextRight, {
        size: iconSize,
        className: "tw-text-neutral-light-700"
      })
    }), label && /*#__PURE__*/_jsx("p", {
      className: "tw-text-neutral-light-700 tw-text-1.4 tw-font-normal tw-hidden sm:tw-block ".concat(labelClassName),
      children: label
    })]
  });
};